import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Animated, View, } from 'react-native';
import FastImage from 'utils/packages/rnFastImage';
import { extractImage } from 'utils/imageHelpers';
import checkSource from 'common/imageSourceChecher';
import { rem } from 'design-system/values';
import { IconBank } from 'design-system/icons';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const BankLogo = ({ bankAccount, style }) => {
    const [size, setSize] = useState(0);
    const image = useMemo(() => extractImage(bankAccount, false), [bankAccount]);
    const animatedValue = useRef(new Animated.Value(0)).current;
    const styles = useStyles(styleSet);
    useEffect(() => {
        const animation = Animated.sequence([
            Animated.loop(Animated.timing(animatedValue, {
                toValue: 3,
                duration: 1000,
                useNativeDriver: true,
            })),
        ]);
        animation.start();
        return () => {
            animation.reset();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [hasError, setHasError] = useState(false);
    const onError = () => setHasError(true);
    const onLayout = (layoutEvent) => {
        setSize(Math.min(layoutEvent.nativeEvent.layout.height, layoutEvent.nativeEvent.layout.width));
    };
    const ringMap = animatedValue.interpolate({
        inputRange: [0, 1, 2, 3],
        outputRange: [1, 1.2, 1, 1],
    });
    const LogoMap = animatedValue.interpolate({
        inputRange: [0, 1, 2, 3],
        outputRange: [1, 0.9, 1.2, 1],
    });
    const getScaledSize = (scale) => ({
        width: size * scale,
        height: size * scale,
        borderRadius: (size * scale) / 2,
    });
    return (<View onLayout={onLayout} style={style}>
      <Animated.View style={[
            styles.ring,
            getScaledSize(1),
            { transform: [{ scale: ringMap }] },
        ]}>
        <Animated.View style={[
            styles.circle,
            getScaledSize(0.77),
            { transform: [{ scale: LogoMap }] },
        ]}>
          {hasError ? (<IconBank gradientKey="brandGradient" width={getScaledSize(0.5).width} height={getScaledSize(0.5).height}/>) : (<FastImage source={checkSource(image)} style={getScaledSize(0.65)} onError={onError}/>)}
        </Animated.View>
      </Animated.View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    ring: {
        borderWidth: rem(2),
        alignSelf: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        borderColor: colors.elements.white,
    },
    circle: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.elements.white,
    },
}));
export default BankLogo;
